import Vue from 'vue'
import axios from 'axios'

import {
  CONTACT_ALL,
  CONTACT_ALL_FOR_FORM,
  CONTACT_CREATE,
  CONTACT_READ,
  CONTACT_UPDATE,
  CONTACT_DELETE
} from '../actions'

import {
  CLEAR_STORE,
  CONTACT_LOADING,
  CONTACT_SUCCESS,
  CONTACT_ERROR,
  CONTACT_SET,
  CONTACTS_SET,
  CONTACT_CURRENT_PAGE_SET,
  CONTACT_PER_PAGE_SET,
  CONTACT_TOTAL_PAGES_SET,
  CONTACT_SEARCH_VALUE_SET
} from '../mutations'

export default {
  state: {
    status: '',
    contacts: [],
    contact: {},
    perPage: 15,
    currentPage: 1,
    totalPages: 0,
    searchValue: ''
  },

  mutations: {
    [CONTACT_LOADING]: (state) => {
      state.status = 'loading'
    },
    [CONTACT_SUCCESS]: (state) => {
      state.status = 'success'
    },
    [CONTACT_ERROR]: (state) => {
      state.status = 'error'
    },
    [CONTACT_SET]: (state, resp) => {
      Vue.set(state, 'contact', resp)
    },
    [CONTACTS_SET]: (state, resp) => {
      Vue.set(state, 'contacts', resp)
    },
    [CONTACT_PER_PAGE_SET]: (state, value) => {
      state.perPage = value
    },
    [CONTACT_CURRENT_PAGE_SET]: (state, value) => {
      state.currentPage = value
    },
    [CONTACT_TOTAL_PAGES_SET]: (state, value) => {
      state.totalPages = value
    },
    [CONTACT_SEARCH_VALUE_SET]: (state, value) => {
      state.searchValue = value
    },
    [CLEAR_STORE]: (state) => {
      Vue.set(state, 'contact', {})
      Vue.set(state, 'contacts', [])
    }
  },

  actions: {
    [CONTACT_ALL]: ({
      commit,
      state,
      getters
    }) => {
      commit(CONTACT_LOADING)

      let accountId = getters.getActiveAccountId

      if (!accountId) {
        commit(CONTACT_ERROR)
        return false
      }

      let params = {
        page: state.currentPage,
        per_page: state.perPage
      }

      if (state.searchValue && state.searchValue.length) {
        params.search = state.searchValue
      }

      axios({
        url: 'accounts/' + accountId + '/search/contacts',
        params: params
      })
        .then(resp => {
          commit(CONTACT_SUCCESS)
          commit(CONTACTS_SET, resp.data.data)
          commit(CONTACT_TOTAL_PAGES_SET, resp.data.meta.last_page)
        })
        .catch(resp => {
          commit(CONTACT_ERROR)
        })
    },
    [CONTACT_ALL_FOR_FORM]: ({
      commit,
      getters
    }) => {
      commit(CONTACT_LOADING)
      return new Promise((resolve, reject) => {
        let accountId = getters.getActiveAccountId

        if (!accountId) {
          commit(CONTACT_ERROR)
          return false
        }

        axios({
          url: 'accounts/' + accountId + '/contacts'
        })
          .then(resp => {
            commit(CONTACT_SUCCESS)
            commit(CONTACTS_SET, resp.data.data)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(CONTACT_ERROR)
            reject(err)
          })
      })
    },

    [CONTACT_READ]: ({
      commit
    }, id) => {
      commit(CONTACT_LOADING)
      commit(CONTACT_SET, {})
      axios({
        url: 'contacts/' + id
      })
        .then(resp => {
          commit(CONTACT_SUCCESS)
          commit(CONTACT_SET, resp.data.data)
        })
        .catch(resp => {
          commit(CONTACT_ERROR)
        })
    },

    [CONTACT_CREATE]: ({
      commit,
      dispatch,
      getters
    }, data) => {
      return new Promise((resolve, reject) => {
        commit(CONTACT_LOADING)
        commit(CONTACT_SET, {})

        let accountId = getters.getActiveAccountId

        if (!accountId) {
          commit(CONTACT_ERROR)
          reject(new Error('No account found'))
          return false
        }

        axios({
          method: 'post',
          url: 'accounts/' + accountId + '/contacts',
          data: data
        })
          .then(resp => {
            commit(CONTACT_SUCCESS)
            commit(CONTACT_SET, resp.data.data)
            dispatch(CONTACT_ALL)
            resolve(resp.data.data)
          })
          .catch(err => {
            commit(CONTACT_ERROR)
            reject(err)
          })
      })
    },

    [CONTACT_UPDATE]: ({
      commit,
      dispatch
    }, {
      id,
      data
    }) => {
      commit(CONTACT_LOADING)
      axios({
        method: 'put',
        url: 'contacts/' + id,
        data: data
      })
        .then(resp => {
          commit(CONTACT_SUCCESS)
          commit(CONTACT_SET, resp.data.data)
          dispatch(CONTACT_ALL)
        })
        .catch(resp => {
          commit(CONTACT_ERROR)
        })
    },

    [CONTACT_DELETE]: ({
      commit,
      dispatch
    }, id) => {
      commit(CONTACT_LOADING)

      axios({
        method: 'delete',
        url: 'contacts/' + id
      })
        .then(resp => {
          commit(CONTACT_SET, {})
          dispatch(CONTACT_ALL)
        })
        .catch(resp => {
          commit(CONTACT_ERROR)
        })
    }
  }
}
